import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleDown, faArrowCircleUp} from "@fortawesome/free-solid-svg-icons";
import Button from "../element/Button";


const styles = {
    default: 'flex w-full rounded-lg px-4 py-2.5 tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100',
    active: 'flex w-full rounded-lg bg-slate-150 px-4 py-2.5 tracking-wide text-slate-800 outline-none transition-all dark:bg-navy-500 dark:text-navy-50'
}

const subChapterStyleNone = {
    textAlign: "left"
}
const subChapterStyle = {
    fontSize: "12pt",
    color: "black",
    textAlign: "left"
}

const ListChapter = ({id, title, active = 'default', isSub = false, onClick, onUp, onDown}) => {
    return <li className={'flex'}>
        <button onClick={onClick} className={styles[active]} style={isSub ? subChapterStyle : subChapterStyleNone}>
            <span>{title}</span>
        </button>
        { onUp &&
        <div className={'w-2/12'} style={{paddingLeft: '5px'}}>
            <Button onClick={onUp} text={<FontAwesomeIcon icon={faArrowCircleUp}/>} type={"info"}/>
        </div>
        }
        { onDown &&
        <div className={'w-2/12'} style={{paddingLeft: '5px'}}>
            <Button onClick={onDown} text={<FontAwesomeIcon icon={faArrowCircleDown}/>} type={"info"}/>
        </div>
        }

    </li>
}

export default ListChapter;
